module.exports = __webpack_public_path__ + "img/5S.4b9cdaae.png";